import { useContext } from 'react';
import { CIHAFiltersContext } from '../contexts/CIHAFiltersContext';

export const useCIHAFiltersContext = () => {
    return useContext(CIHAFiltersContext);
};
